<template>
    <div>
        <el-table
            empty-text="暂无数据"
            :ref="tableName"
            :data="tableList"
            :border="isBorder"
            :stripe="stripe"
            fit
            highlight-current-row
            :row-key="getRowKey"
            :reserve-selection="true"
            :span-method="spanMethod"
            @selection-change="selectionChange"
            @row-click="rowClick"
            :header-cell-style="headerClass"
            :class="{ 'no-data': tableList.length === 0 }"
        >
            <!-- 选择框 -->
            <el-table-column
                v-if="select"
                type="selection"
                :reserve-selection="true"
                width="55"
                align="center"
            />
            <el-table-column
                v-if="isIndex"
                type="index"
                :label="indexLabel"
                align="center"
                width="50"
            ></el-table-column>
            <template v-for="(itm, idx) in header">
                <!-- 特殊处理列 -->
                <el-table-column
                    type="selection"
                    :reserve-selection="true"
                    width="55"
                    align="center"
                    v-if="itm.checkBox"
                    :key="idx"
                    :selectable='itm.formatter'
                    :show-overflow-tooltip="itm.tooltip"
                >
                </el-table-column>
                <el-table-column
                    v-else-if="itm.render"
                    :key="idx"
                    :prop="itm.prop ? itm.prop : null"
                    :index="itm.index ? itm.index : null"
                    :label="itm.label ? itm.label : null"
                    :width="itm.width ? itm.width : null"
                    :sortable="itm.sortable ? itm.sortable : false"
                    :align="itm.align ? itm.align : 'center'"
                    :fixed="itm.fixed ? itm.fixed : null"
                    :min-width="itm.minWidth ? itm.minWidth : 50"
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <ex-slot
                            :cancel="itm.cancel"
                            :render="itm.render"
                            :row="scope.row"
                            :index="scope.$index"
                            :column="itm"
                        />
                    </template>
                </el-table-column>
                <slot v-else-if="itm.slot" :name="itm.slot"></slot>
                <!-- 正常列 -->
                <!-- <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="itm.prop ? itm.prop : null"
                    placement="bottom"
                    :key="idx"
                > -->
                    <el-table-column
                        v-else
                        :key="idx"
                        :prop="itm.prop ? itm.prop : null"
                        :label="itm.label ? itm.label : null"
                        :width="itm.width ? itm.width : null"
                        :sortable="itm.sortable ? itm.sortable : false"
                        :align="itm.align ? itm.align : 'center'"
                        :fixed="itm.fixed ? itm.fixed : null"
                        :formatter="itm.formatter"
                        :min-width="itm.minWidth ? itm.minWidth : 50"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                <!-- </el-tooltip> -->
            </template>
            <slot name="empty" slot="empty"></slot>
        </el-table>
        <div class="page-block" v-if="tableList.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="activePage"
                :page-sizes="[10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                background
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
var exSlot = {
    functional: true,
    props: {
        row: Object,
        render: Function,
        cancel:Function,
        index: Number,
        column: {
            type: Object,
            default: null,
        },
    },
    render: (h, context) => {
        const params = {
            row: context.props.row,
            index: context.props.index,
        };
        if (context.props.column) params.column = context.props.column;
        return context.props.render(h, params);
    },
};
export default {
    name: "ExTable",
    props: {
        tableList: {
            type: Array,
            default: () => [],
        },
        stripe:{ type: Boolean, default: true },
        tableName:{ type: String, default: "table" },
        header: {
            type: Array,
            default: () => [],
        },
        select: {
            type: Boolean,
            default: () => false,
        },
        isIndex: {
            type: Boolean,
            default: () => true,
        },
        total: {
            type: Number,
            default: 10,
        },
        tooltip:{
            type: Boolean,
            default: () => true,
        },
        isBorder:{
            type: Boolean,
            default: () => true,
        },
        indexLabel: { type: String, default: "序号" },
        tableId: { type: Number, default: 1 },
        activeIndex: { type: Number, default: 1 },
        spanMethod:{type: Function, default: null},
        pageSizeNum: { type: Number, default: 10 },
    },
    data() {
        return {
            currentPage:1,
            pageSize: this.pageSizeNum,
            activePage:this.activeIndex,
        };
    },
    components: {
        exSlot,
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {});
    },
    destroyed() {},
    watch: {
        tableList() {
            this.$nextTick(() => {});
        },
        activeIndex(){
            this.activePage=this.activeIndex;
        },
        pageSizeNum(){
            this.pageSize=this.pageSizeNum;
        }
    },
    methods: {

        getRowKey(row){
          return row.id
        },
        handleSizeChange(val) {
            this.currentPage=1;
            this.$emit("clickSize", val, this.tableId);
        },
        handleCurrentChange(val) {
            console.log('aaa'+val)
            this.$emit("clickPage", val, this.tableId);
        },
        selectionChange(selection) {
            this.$emit("selection-change", selection);
        },
        rowClick(row, column, event) {
            this.$emit("row-click", row, column, event);
        },
        headerClass({ row, index }) {
            // return 'background:#3F7DF7;color:#fff'
        },
    },
};
</script>

<style scoped>
.el-table.no-data::before {
    display: none !important;
}
</style>
